import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { AiAgentsHeroSection } from "@/components/insights/ai-agents/AiAgentsHeroSection";
import { AiAgentsTakeaway } from "@/components/insights/ai-agents/AiAgentsTakeaway";
import { AiAgentsFounderQuote } from "@/components/insights/ai-agents/AiAgentsFounderQuote";
import { AiAgentsUseCases } from "@/components/insights/ai-agents/AiAgentsUseCases";
import { AiAgentsBuildGuide } from "@/components/insights/ai-agents/AiAgentsBuildGuide";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const AiAgentsAutomation = () => {
  return (
    <>
      <InsightEngagementTracker slug="ai-agents-automation" title="AI Agents & Automation" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="AI Development" 
          currentPage="AI Agents & Automation" 
        />
        <AiAgentsHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <AiAgentsTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <AiAgentsFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <AiAgentsUseCases />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <AiAgentsBuildGuide />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="ai-agents-automation" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="ai-agents-automation" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default AiAgentsAutomation;
